import { Requester } from './Requester';

export const PostExportConfig = async (sheets: string[]): Promise<boolean> => {
    try {
        const response = await Requester<any>({
            path: `import/export/all`,
            method: 'POST',
            isFileDownload: true,
            payload: {
                sheets
            }
        });

        return response;
    } catch (e) {
        console.error('Download export request failed');
        return Promise.reject(e);
    }
};
